"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { Phone, Mail } from "lucide-react";
export default function ContactCallToAction() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  return <section ref={ref} className="relative bg-background py-16 px-4 sm:px-6 lg:px-8 overflow-hidden">
      <div className="max-w-3xl mx-auto text-center">
        <div className={`transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold text-foreground mb-4">
            Ready to Streamline Your Operations?
          </h2>
          <p className="text-foreground/80 text-base sm:text-lg mb-8 max-w-2xl mx-auto leading-relaxed">
            Let's discuss how Freedom Productions can help you achieve measurable growth, stay organized, and bring your creative projects to life.
          </p>

          <Link to="/ContactPage">
            <Button size="lg" className="bg-primary text-foreground-primary hover:bg-primary-hover hover:scale-105 transition-all duration-[var(--duration-medium)] ease-[var(--ease-spring)] shadow-soft hover:shadow-medium px-8 py-6 text-base font-semibold rounded-md">
              Schedule a Consultation
            </Button>
          </Link>

          <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-6 text-foreground/70 text-sm">
            <div className="flex items-center gap-2">
              <Phone className="size-4" />
              <span>541-215-6033</span>
            </div>
            <div className="flex items-center gap-2">
              <Mail className="size-4" />
              <span>info@freedomproductionsor.com</span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}